export const titles = [
  'Date',
  'From',
  'To',
  'Wholesale Cost',
  'Status',
  'Created By',
];
